/* unplugin-vue-components disabled */import { render } from "./style4.vue?vue&type=template&id=cd3f97ca&scoped=true"
import script from "./style4.vue?vue&type=script&lang=js"
export * from "./style4.vue?vue&type=script&lang=js"

import "./style4.vue?vue&type=style&index=0&id=cd3f97ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3f97ca"]])

export default __exports__